import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/azierta-integrada-por-completo-a-qbdgroup-hr")({
  head: () => buildRouteHead("/es/azierta-integrada-por-completo-a-qbdgroup-hr", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/sobre-qbd/historia", replace: true });
  },
});
